<template>
  <div class="recommend-card-wrapper">
    <w-nav-bar nav_title="今日推荐" :right_btn_html="rightHtml" icon=" "/>
    <div class="recommend-card-content">
      <div class="recommend-card-container" :style="containerStyle">
        <div v-for="(item,index) in jdList" :key="index" class="card-content">
          <cube-scroll :data="[jobIndex]">
            <job-detail :detail-data="item"/>
          </cube-scroll>
          <div class="next-job flex-center" @click="changeJobIndex(item)">
            <span class="iconfont iconxiangxiajiantou"/>
          </div>
          <div class="operation-footer flex">
            <div class="job-like flex-center" :class="{'dis-card': item.is_discard}" @click="dislike(item)">
              <span class="iconfont iconGroup112"/>
            </div>
            <button class="theme-button flex-center like-btn" @click="changeLike(item)">
              <span class="iconfont iconbaisexingxing"/>
              <span>{{ item.is_like ? '已收藏' : '收藏' }}</span>
            </button>
            <button class="flex-center mailing-btn" @click="sendMailing" :disabled="item.is_apply">
              <span class="iconfont iconbaifeiji"/>
              <span>{{ item.is_apply ? '已投递' : '投递' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <job-alert v-if="jobInfo" :state="jobAlertShow" :page-data="pageData" @handleClose="jobAlertShow = false"/>
    <job-mailing v-if="jobInfo" :state="mailingShow" :cv-data="cvList" @handleClose="mailingShow = false"
                 @sendMailing="mailing"/>
    <w-toast v-show="toastShow" :toast-data="toastData"/>
    <w-loading v-show="loadingShow" :show-text="true"/>
    <w-tab-bar page="job"/>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import WTabBar from '../../components/global/w-tabbar'
	import WLoading from '../../components/global/w-loading'
	import WToast from '../../components/global/w-toast'
	import jobDetail from '../job-components/job-detail-recommend'
	import jobAlert from '../job-components/job-alert'
	import jobMailing from '../job-components/job-mailing'
	import { jobsMixin } from '../../assets/js/mixin/jobs'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { loginMixin, windowEventMixin } from '../../assets/js/mixin/global'
	import { mapActions, mapState } from 'vuex'

	let moment = require('moment')

	export default {
		name: 'recommend-jd-card',
		mixins: [ jobsMixin, componentsMixin, loginMixin, windowEventMixin ],
		data () {
			return {
				jobIndex: 0,
				jobList: [],
				containerStyle: {},
				nextPageData: {},
				toastData: {
					imgUrl: 'https://files.wondercv.com/jobs/mailing.png',
					txt: '投递成功'
				},
				toastShow: false,
				jobApplicationId: null
			}
		},
		async mounted () {
			this.verifyLogged()
			this._getJobList()
			await this.getJdJobsList()
      await this.initJobIndex()
			this._getMailingData()
			// this.getNextData()
		},
		computed: {
			...mapState('jobs', [ 'jdList' ]),
			rightHtml () {
				return `<p class="job-num"><span class="current-job">${ this.jobIndex + 1 }</span>/${ this.jdList.length }</p>`
			},
			jobInfo () {
				return this.pageData.recruit_info
			}
		},
		watch: {
			jobIndex: {
				handler (val) {
					let el = document.querySelector('.recommend-card-container')
					if (el) {
						// this.pageData = this.nextPageData
						let y = val * el.clientHeight
						this.containerStyle = { transform: `translateY(${ -y }px)` }
						// if (this.jobIndex < this.jdList.length - 1) this.getNextData()
					} else {
						this.containerStyle = {}
					}
				},
				immediate: true
			}
		},
		components: {
			WNavBar,
			WTabBar,
			WLoading,
			WToast,
			awaitLoading: WLoading,
			jobDetail,
			jobAlert,
			jobMailing
		},
		methods: {
			...mapActions('jobs', [ 'getJdJobsList' ]),
			initJobIndex () {
				const index = this.jdList.findIndex(v => !v.operation)
				if (index > -1) {
					this.jobIndex = index
				} else {
					this.$router.push('/jobs/recommend')
				}
				this.loading = false
			},
			async getNextData () {
				let nextData = await this.$api.jobs.getJobInfo(this.jdList[this.jobIndex + 1].token)
				if (nextData.code === 1000) this.nextPageData = nextData.data
			},
			async _getJobList () {
				// let res = await this.$api.HrApi.getInternalList({ jd_flag: 1, from: 0, size: 10 })
				// if (res.code === 1000) this.jobList = res.data.jobs
				this.$db.ls.set(`${ moment().format('YYYY-MM-DD') }-point`, true)
			},
			async _getMailingData () {
				let res = await this.$api.jobs.getJobInfo(this.jdList[this.jobIndex].token)
				if (res.code === 1000) this.pageData = res.data
			},
			changeJobIndex (item) {
				this.changeJobsOperation(item.token, 'next')
        this.mailingShow = false
        this.jobAlertShow = false
				if (this.jobIndex < this.jdList.length - 1) {
					this.jobIndex += 1
					this.jobApplicationId = null
					this.$forceUpdate()
				} else {
          this.$router.push('/jobs/recommend')
					// this.$router.push('/jobs/recommend-jd-card/finish')
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .recommend-card-wrapper {
    /deep/ .job-num {
      color: $color-title;
      .current-job {
        color: $color-theme
      }
    }
    padding: 60px 0 16px;
    height: calc(var(--vh, 1vh) * 100);
    background-color: #F9F9F9;
    overflow: hidden;
    @include ipx-content-bottom(66px);
    .recommend-card-content {
      height: 100%;
      overflow: hidden;
      padding: 0 16px;
      .recommend-card-container {
        height: 100%;
        box-shadow: 0 2px 20px 0 rgba($color: #D4D4D4, $alpha: .1);
        transition: all .3s;
        .card-content {
          background-color: $color-light;
          width: 100%;
          height: 100%;
          border-radius: 6px;
          padding: 24px 24px 96px;
          position: relative;
        }
        .next-job {
          position: absolute;
          right: 24px;
          bottom: 98px;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          box-shadow: 0px 4px 8px 0px rgba(186, 186, 186, 0.5);
          color: #D9D9D9;
          z-index: 9;
          background-color: $color-light;
        }
        .operation-footer {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 18px 24px;
          z-index: 9;
          background-color: $color-light;
          box-shadow: 0px -4px 9px -4px rgba(237, 237, 237, 0.5);
          border-radius: 0px 0px 6px 6px;
          .job-like {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: rgba($color: #D9D9D9, $alpha: .3);
            margin-right: 40px;
            color: #9C9C9C;
            .iconfont {
              font-weight: bold;
              font-size: 12px;
              /*font-size: 20px;*/
            }
          }
          .dis-card {
            background-color: #CFCFCF;
            color: $color-light;
          }
          .like-btn, .mailing-btn {
            width: 100px;
            height: 36px;
            border-radius: 18px;
            font-size: $font-size-medium;
            .iconfont {
              margin-right: 8px;
            }
          }
          .is-like {
            background-color: #CFCFCF;
          }
          .mailing-btn {
            background-color: #4183FF;
            color: $color-light;
            outline: none;
            border: none;
            margin-left: 16px;
            /*&:disabled {*/
            /*  background-color: #CFCFCF;*/
            /*}*/
          }
        }
      }
    }
  }
</style>
